import React from 'react';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { FaSearch, FaTimes, FaPlus, FaPrint } from 'react-icons/fa';
import { selectStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { STATUS_CONTRATO } from '~/constant';

const opcoesStatus = Object.entries(STATUS_CONTRATO).map(([k, v]) => ({
  value: Number(k),
  label: v,
}));

const FiltroContratos = ({
  filtros,
  gruposEmpresa,
  contas,
  empreendimentos,
  imoveis,
  onAtualizarFiltro,
  onBuscar,
  onLimpar,
  onIncluir,
  onExportar,
  pesquisado,
  loading,
}) => {
  const opcoesGruposEmpresa = (gruposEmpresa || []).map((g) => ({
    value: g.codigo,
    label: `${g.codigo} - ${g.apelido || g.descricao || g.nome || ''}`,
  }));

  const opcoesContas = (contas || []).map((c) => ({
    value: c.codigo,
    label: `${c.codigo} - ${c.apelido || c.nome || ''}`,
  }));

  const opcoesEmpreendimentos = (empreendimentos || []).map((e) => ({
    value: e.codigo,
    label: e.descricao || e.nome,
  }));

  const opcoesImoveis = (imoveis || []).map((i) => ({
    value: i.codigo,
    label: i.descricao,
  }));

  const handleBoletoChange = (e) => {
    const val = e.target.value ? Number(e.target.value) : null;
    onAtualizarFiltro('boleto', val);
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="mb-2">
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Grupo Empresa</Form.Label>
              <Select
                placeholder="Selecione"
                options={opcoesGruposEmpresa}
                value={
                  opcoesGruposEmpresa.find(
                    (o) => o.value === filtros.codigoGrupoEmpresa
                  ) || null
                }
                onChange={(sel) =>
                  onAtualizarFiltro('codigoGrupoEmpresa', sel ? sel.value : null)
                }
                isClearable
                styles={selectStylesSm}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Boleto</Form.Label>
              <Form.Control
                size="sm"
                type="number"
                placeholder="Nº Boleto"
                value={filtros.boleto || ''}
                onChange={handleBoletoChange}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Conta (Cliente)</Form.Label>
              <Select
                placeholder="Selecione"
                options={opcoesContas}
                value={
                  opcoesContas.find((o) => o.value === filtros.codigoConta) || null
                }
                onChange={(sel) =>
                  onAtualizarFiltro('codigoConta', sel ? sel.value : null)
                }
                isClearable
                isDisabled={!filtros.codigoGrupoEmpresa}
                styles={selectStylesSm}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Status</Form.Label>
              <Select
                placeholder="Todos"
                options={opcoesStatus}
                value={opcoesStatus.find((o) => o.value === filtros.status) || null}
                onChange={(sel) => onAtualizarFiltro('status', sel ? sel.value : null)}
                isClearable
                styles={selectStylesSm}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Empreendimento</Form.Label>
              <Select
                placeholder="Selecione"
                options={opcoesEmpreendimentos}
                value={
                  opcoesEmpreendimentos.find(
                    (o) => o.value === filtros.codigoEmpreendimento
                  ) || null
                }
                onChange={(sel) =>
                  onAtualizarFiltro('codigoEmpreendimento', sel ? sel.value : null)
                }
                isClearable
                isDisabled={!filtros.codigoGrupoEmpresa}
                styles={selectStylesSm}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Imóvel</Form.Label>
              <Select
                placeholder="Selecione"
                options={opcoesImoveis}
                value={
                  opcoesImoveis.find((o) => o.value === filtros.codigoImovel) || null
                }
                onChange={(sel) =>
                  onAtualizarFiltro('codigoImovel', sel ? sel.value : null)
                }
                isClearable
                isDisabled={!filtros.codigoEmpreendimento}
                styles={selectStylesSm}
                components={{ DropdownIndicator }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} sm={6} md={3}>
            <Row>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label className="small mb-1">Período de</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    value={filtros.dataIni || ''}
                    onChange={(e) => onAtualizarFiltro('dataIni', e.target.value || null)}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group>
                  <Form.Label className="small mb-1">Até</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    value={filtros.dataFim || ''}
                    onChange={(e) => onAtualizarFiltro('dataFim', e.target.value || null)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="d-flex justify-content-end">
            <Button
              size="sm"
              variant="outline-secondary"
              className="mr-2"
              onClick={onLimpar}
              disabled={loading}
            >
              <FaTimes className="mr-1" /> Limpar
            </Button>
            <Button
              size="sm"
              variant="primary"
              className="mr-2"
              onClick={() => onBuscar()}
              disabled={loading}
            >
              <FaSearch className="mr-1" /> Buscar
            </Button>
            <Button
              size="sm"
              variant="success"
              className="mr-2"
              onClick={onIncluir}
              disabled={loading}
            >
              <FaPlus className="mr-1" /> Incluir
            </Button>
            {pesquisado && (
              <Button
                size="sm"
                variant="outline-primary"
                onClick={onExportar}
                disabled={loading}
              >
                <FaPrint className="mr-1" /> Imprimir PDF
              </Button>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FiltroContratos;
